/* Component for displaying driver document details. */

import {
  Box,
  Typography,
  Grid,
  Button,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
  Paper,
  Modal,
  TextField,
  CircularProgress,
  Snackbar,
  Alert,
  AccordionDetails,
  AccordionSummary,
  Accordion,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import BackIcon from "@mui/icons-material/ArrowBackIos";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import SidePanel from "../../components/SidePanel";
import TopBar from "../../components/TopBar";
import { getDriver, updateVtcStatus } from "../../apis/drivers";

import "./style.css";

const DriverDetails = () => {
  const { driver } = useSelector((state: any) => state.driverReducer);
  const params = useParams();
  const navigate = useNavigate();

  const [driverData, setDriverData] = useState(driver);
  const [openRejectDocModal, setOpenRejectDocModal] = useState(false);
  const [rejectRemark, setRejectRemark] = useState("");
  const [loading, setLoading] = useState(false);
  const [approveSnackbar, setApproveSnackbar] = React.useState(false);
  const [rejectSnackbar, setRejectSnackbar] = React.useState(false);
  const driverId = params.id;

  //methods
  const goToBack = () => navigate("/driver-documentation");

  const formatDate = (timestamp: string) => {
    var parsedTimestamp = new Date(timestamp);

    // Format it as "Dec 12, 2023"
    var options: any = { year: "numeric", month: "short", day: "numeric" };
    var formattedTimestamp = parsedTimestamp.toLocaleDateString("en-US", options);

    return formattedTimestamp;
  };

  function refreshPage() {
    window.location.reload();
  }

  const handleOpen = () => setOpenRejectDocModal(true);
  const handleClose = () => setOpenRejectDocModal(false);

  const openSnackBar = () => {
    setApproveSnackbar(true);
  };
  const closeSnackBar = (event: React.SyntheticEvent | Event, reason?: string) => {
    setApproveSnackbar(false);
  };

  const openRejctSnackBar = () => {
    setRejectSnackbar(true);
  };
  const closeRejectSnackBar = (event: React.SyntheticEvent | Event, reason?: string) => {
    setRejectSnackbar(false);
  };

  const approveDocument = async () => {
    //API for approving the driver
    const body = {
      vtcStatus: "approved",
    };
    let res = await updateVtcStatus(driverId, body);
    openSnackBar();
    if (res?.status) {
      refreshPage();
    }
  };

  const rejectDocument = async () => {
    //API for rejecting the driver
    const body = {
      vtcStatus: "rejected",
      remark: rejectRemark,
    };
    let res = await updateVtcStatus(driverId, body);
    openRejctSnackBar();
    if (res?.status) {
      refreshPage();
    }
  };

  const onHandleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRejectRemark(event.target.value);
  };

  const getDriverById = async (id: any) => {
    setLoading(true);
    const data = await getDriver(id);
    setDriverData(data);
    setLoading(false);
  };

  useEffect(() => {
    const id = driverId !== undefined ? driverId : "";
    getDriverById(id);
  }, []);

  return (
    <Box className="mainContainer">
      <Box className="sidePanelContainer">
        <SidePanel isOpen={true} onClose={() => {}} />
      </Box>
      <Box className="dashboardContainer">
        <TopBar />
        <Box style={{ width: "100%", marginTop: "5%" }} component={Paper}>
          {loading ? (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginTop: "200px",
              }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <Box>
              {/* <Box>
                <Button
                  style={{ backgroundColor: "gray", margin: "20px" }}
                  variant="contained"
                  startIcon={<BackIcon />}
                >
                  Back
                </Button>
              </Box> */}
              <Typography
                style={{
                  fontSize: 16,
                  fontWeight: 700,
                  margin: "30px 0px 30px 0px",
                  backgroundColor: "#9BCBEC",
                  padding: "15px",
                }}
              >
                Driver Details
              </Typography>
              <Box style={{ margin: "20px" }}>
                <Grid container spacing={2}>
                  <Grid item xs={4}>
                    <Typography className="detailsLabel">Driver Name</Typography>
                    <Typography>
                      {driverData.firstName} {driverData.lastName}
                    </Typography>
                  </Grid>
                  <Grid item xs={4}>
                    <Typography className="detailsLabel">Phone</Typography>
                    <Typography>{driverData.phone}</Typography>
                  </Grid>
                  <Grid item xs={4}>
                    <Typography className="detailsLabel">Email</Typography>
                    <Typography>{driverData.email}</Typography>
                  </Grid>
                  <Grid item xs={4}>
                    <Typography className="detailsLabel">Rating</Typography>
                    <Typography>{driverData?.rating && (driverData?.rating).toFixed(2)}</Typography>
                  </Grid>
                  <Grid item xs={4}>
                    <Typography className="detailsLabel">Status</Typography>
                    <Typography className="textCapitalize">
                      {driverData.vtcStatus ? driverData.vtcStatus : "pending"}
                    </Typography>
                  </Grid>
                  <Grid item xs={4}>
                    <Typography className="detailsLabel">
                      Stripe Account Verification Status
                    </Typography>
                    <Typography className="textCapitalize">
                      {driverData.stripeAccountVerificationStatus
                        ? driverData.stripeAccountVerificationStatus
                        : "pending"}
                    </Typography>
                  </Grid>
                </Grid>
              </Box>
              <Box>
                <Typography
                  style={{
                    fontWeight: "bold",
                    fontSize: 16,
                    marginTop: "50px",
                    marginBottom: "50px",
                    //borderTop: "solid 1px grey",
                    backgroundColor: "#9BCBEC",
                    padding: "15px",
                  }}
                >
                  Driver Documents
                </Typography>
                {driverData?.documents?.length > 0 ? (
                  <Box style={{ margin: "20px" }}>
                    <TableContainer component={Paper}>
                      <Table sx={{ minWidth: 650 }} aria-label="simple table">
                        <TableHead style={{ backgroundColor: "rgb(224, 224, 224)" }}>
                          <TableRow>
                            <TableCell className="cellContainer">ID</TableCell>
                            <TableCell className="cellContainer">File</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {driverData.documents.map((row: any) => {
                            return (
                              <TableRow
                                key={row._id}
                                sx={{
                                  "&:last-child td, &:last-child th": { border: 0 },
                                }}
                              >
                                <TableCell component="th" scope="row">
                                  {row._id}
                                </TableCell>
                                <TableCell>
                                  <a href={row.url} target="_blank">
                                    {row.name}
                                  </a>
                                </TableCell>
                              </TableRow>
                            );
                          })}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Box>
                ) : (
                  <Typography style={{ textAlign: "center" }}>No Documents</Typography>
                )}
              </Box>
              <Box>
                <Typography
                  style={{
                    fontWeight: "bold",
                    fontSize: 18,
                    marginTop: "50px",
                    marginBottom: "50px",
                    backgroundColor: "#9BCBEC",
                    padding: "15px",
                  }}
                >
                  Cars
                </Typography>
                {driverData.cars.map((item: any) => (
                  <Box style={{ margin: "20px" }}>
                    <Accordion elevation={4}>
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                      >
                        <Typography className="detailsLabel">Model: {item.car_model}</Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Grid container spacing={2}>
                          {/* <Grid item xs={4}>
                            <Typography className="detailsLabel">Car Model</Typography>
                            <Typography>{item.car_model ? item.car_model : "--"}</Typography>
                          </Grid> */}
                          <Grid item xs={4}>
                            <Typography className="detailsLabel">Car Maker</Typography>
                            <Typography>{item.car_make ? item.car_make : "--"}</Typography>
                          </Grid>
                          <Grid item xs={4}>
                            <Typography className="detailsLabel">Year</Typography>
                            <Typography>{item.car_year ? item.car_year : "--"}</Typography>
                          </Grid>
                          <Grid item xs={4}>
                            <Typography className="detailsLabel">License Plate</Typography>
                            <Typography>
                              {item.license_plate ? item.license_plate : "--"}
                            </Typography>
                          </Grid>
                          <Grid item xs={4}>
                            <Typography className="detailsLabel">Car Type</Typography>
                            <Typography>{item.car_type ? item.car_type : "--"}</Typography>
                          </Grid>
                          <Grid item xs={4}>
                            <Typography className="detailsLabel">Doors</Typography>
                            <Typography>{item.doors ? item.doors : "--"}</Typography>
                          </Grid>
                          <Grid item xs={4}>
                            <Typography className="detailsLabel">No. of Seats</Typography>
                            <Typography>{item.total_seats ? item.total_seats : "--"}</Typography>
                          </Grid>
                          <Grid item xs={4}>
                            <Typography className="detailsLabel">Status</Typography>
                            <Typography>{item.status ? item.status : "--"}</Typography>
                          </Grid>
                          <Grid item xs={4}>
                            <Typography className="detailsLabel">VIN</Typography>
                            <Typography>{item.vin ? item.vin : "--"}</Typography>
                          </Grid>
                          <Grid item xs={4}>
                            <Typography className="detailsLabel">VTC</Typography>
                            <Typography>{item.vtc ? "Yes" : "No"}</Typography>
                          </Grid>
                          <Grid item xs={4}>
                            <Typography className="detailsLabel">Available</Typography>
                            <Typography>{item.available ? "Yes" : "No"}</Typography>
                          </Grid>
                          <Grid item xs={4}>
                            <Typography className="detailsLabel">Maintained At</Typography>
                            <Typography>
                              {item.maintained_at ? formatDate(item.maintained_at) : "--"}
                            </Typography>
                          </Grid>
                          <Grid item xs={4}>
                            <Typography className="detailsLabel">Created At</Typography>
                            <Typography>
                              {item.created_at ? formatDate(item.created_at) : "--"}
                            </Typography>
                          </Grid>
                        </Grid>
                        <Box>
                          <Typography
                            style={{
                              fontWeight: "bold",
                              marginTop: "50px",
                              marginBottom: "50px",
                              borderTop: "solid 1px grey",
                              paddingTop: "2%",
                            }}
                          >
                            Documents
                          </Typography>
                          {item.list_document_id.length > 0 ? (
                            <TableContainer component={Paper}>
                              <Table sx={{ minWidth: 650 }} aria-label="simple table">
                                <TableHead style={{ backgroundColor: "rgb(224, 224, 224)" }}>
                                  <TableRow>
                                    <TableCell align="center" className="cellContainer">
                                      ID
                                    </TableCell>
                                    <TableCell align="center" className="cellContainer">
                                      Document Type
                                    </TableCell>
                                    <TableCell align="center" className="cellContainer">
                                      File
                                    </TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {item.list_document_id.map((row: any, index: number) => {
                                    return (
                                      <TableRow
                                        key={index}
                                        sx={{
                                          "&:last-child td, &:last-child th": { border: 0 },
                                        }}
                                      >
                                        <TableCell align="center" component="th" scope="row">
                                          {index + 1}
                                        </TableCell>
                                        <TableCell align="center">
                                          {index === 0
                                            ? "RC"
                                            : index === 1
                                            ? "VTC Photo"
                                            : index === 2
                                            ? "Insurance"
                                            : index === 3
                                            ? "Vehicle Photo"
                                            : index === 4 || index === 5 || index === 6
                                            ? "Vehicle Technical Inspection"
                                            : null}
                                        </TableCell>
                                        <TableCell align="center">
                                          <a href={row} target="_blank">
                                            {index === 0
                                              ? "RC"
                                              : index === 1
                                              ? "VTC Photo"
                                              : index === 2
                                              ? "Insurance"
                                              : index === 3
                                              ? "Vehicle Photo"
                                              : index === 4 || index === 5 || index === 6
                                              ? "Vehicle Technical Inspection"
                                              : null}
                                          </a>
                                        </TableCell>
                                      </TableRow>
                                    );
                                  })}
                                </TableBody>
                              </Table>
                            </TableContainer>
                          ) : (
                            <Typography style={{ textAlign: "center" }}>No Documents</Typography>
                          )}
                        </Box>
                      </AccordionDetails>
                    </Accordion>
                  </Box>
                ))}
              </Box>
              <Box
                style={{
                  display: "flex",
                  marginTop: "5%",
                  alignItems: "center",
                  justifyContent: "end",
                  marginBottom: "20px",
                  marginRight: "20px",
                }}
              >
                <Button
                  variant="contained"
                  style={{ marginRight: "5px" }}
                  disabled={driverData.vtcStatus === "approved"}
                  onClick={approveDocument}
                >
                  Approve
                </Button>
                <Snackbar
                  anchorOrigin={{ vertical: "top", horizontal: "right" }}
                  open={approveSnackbar}
                  autoHideDuration={3000}
                  onClose={closeSnackBar}
                >
                  <Alert
                    onClose={closeSnackBar}
                    severity="success"
                    sx={{ width: "100%", alignItems: "center" }}
                  >
                    Driver is approved!
                  </Alert>
                </Snackbar>
                <Button
                  variant="contained"
                  disabled={driverData.vtcStatus === "rejected"}
                  onClick={handleOpen}
                >
                  Reject
                </Button>
                <Snackbar
                  anchorOrigin={{ vertical: "top", horizontal: "right" }}
                  open={rejectSnackbar}
                  autoHideDuration={3000}
                  onClose={closeRejectSnackBar}
                >
                  <Alert
                    onClose={closeRejectSnackBar}
                    severity="error"
                    sx={{ width: "100%", alignItems: "center" }}
                  >
                    Driver is rejected!
                  </Alert>
                </Snackbar>
                <Modal
                  open={openRejectDocModal}
                  onClose={handleClose}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <Box
                    sx={{
                      position: "absolute" as "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      width: 400,
                      bgcolor: "background.paper",
                      boxShadow: 24,
                      p: 4,
                    }}
                  >
                    <Box>
                      <Box sx={{ display: "flex", justifyContent: "end", marginBottom: 1 }}>
                        <CloseIcon sx={{ cursor: "pointer" }} onClick={handleClose} />
                      </Box>
                      <Box style={{ marginBottom: "30px" }}>
                        <Typography
                          style={{ fontWeight: "bold" }}
                          id="modal-modal-title"
                          variant="h6"
                          component="h2"
                        >
                          Remarks
                        </Typography>
                      </Box>
                    </Box>
                    <Box
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        padding: "20px",
                      }}
                    >
                      <TextField
                        id="standard-multiline-static"
                        size="small"
                        name="remarks"
                        multiline
                        rows={2}
                        variant="standard"
                        style={{ marginBottom: "10px", width: "100%" }}
                        onChange={onHandleChange}
                      />
                    </Box>
                    <Box
                      sx={{ display: "flex", justifyContent: "end", marginBottom: 1 }}
                      onClick={() => handleClose()}
                    >
                      <Button
                        variant="contained"
                        onClick={rejectDocument}
                        disabled={rejectRemark === ""}
                      >
                        Submit
                      </Button>
                    </Box>
                  </Box>
                </Modal>
              </Box>
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default DriverDetails;
